import {Injectable,Inject} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";
import { IPromise } from 'angular';
import {SharedSessionStorage} from "../../../infra/sharedSessionStorage.service";
import primolyticsService from '../../../analytics/primolytics.service';
import { MendeleyToastService } from './mendeleyToast/mendeleyToast.service';
import {getVid, getBackendSystem} from '../../../appConfig/appConfigForward';

const _get = require('lodash/get');
const _set = require('lodash/set');
const _escape = require('lodash/escape');
const MENDELEY_CREATE_DOCUMENT_API = 'https://api.mendeley.com/documents';


@Injectable()
export class MendeleyService {
    
    private vid:string = getVid();
    public popupMendeleyLoginWin: ng.IWindowService;
    private _token: Object;
    private MENDELEY_API_URL: string;
    private MENDELEY_TOKEN: string = 'mendeley_token';
    private storageEventHandler;
    constructor(private pushtoService: PushtoService,
                private sharedSessionStorage: SharedSessionStorage,
                private mendeleyToastService: MendeleyToastService,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$interval') private $interval: ng.IIntervalService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs){
        this.MENDELEY_API_URL = restBaseURLs.actionsBaseURL+'/mendeley';
    }
    
    public async mendeleyAction(item,selectedIds){
        let title = this.getItemTitle(item);
        try{
            this._token = this.getSessionToken();
            if(this.isAuthorizationNeeded(this._token)){
                await this.getTokenFromApi();
            }
            this.mendeleyToastService.showInProgressToast();
            let failedAction = angular.bind(this, this.failedPushtoAction, title);
            let successAction = angular.bind(this, this.successfullPushtoAction, title);
            let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'mendeley');
            pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
        }catch(err){
            console.log("Mendeley call failed: login to Mendeley failed." + err);
            this.mendeleyToastService.showMendeleyToast(false, title);
        }
    }
    
    private successfullPushtoAction(title, response) {
        let mendeleyRecords = response.data.data;
        let promises = [];
        if(mendeleyRecords && mendeleyRecords.length > 0){
            mendeleyRecords.forEach((item) => {promises.push(this.createDocumentRequest(item))});
            this.$q.all(promises).then((pushtoResponse) => {
                console.log("Mendeley successfully sent");
                this.mendeleyToastService.showMendeleyToast(true, title);
            }, (err) => {
                console.log("Mendeley call failed: " + _get(err,'data.message',''));
                this.mendeleyToastService.showMendeleyToast(false, title);
            });
        }else{
            console.log("No records to export to Mendeley");
            this.mendeleyToastService.showMendeleyToast(false, title);
        }
    }

    private failedPushtoAction(title, response) {
        console.log("Mendeley call failed: server error.");
        this.mendeleyToastService.showMendeleyToast(false, title);
    }

    private async getTokenFromApi(){
        let q = this.$q.defer();
        try{
            let response = await this.authorizationUrlRequest();
            let authenticationUri = _get(response, 'data.authorization_url');
            if(authenticationUri){
                let code = await this.mendeleyLogin(authenticationUri);
                let token =  await this.tokenRequest(code);
                token = _get(token,'data.token',{});
                this.setSessionToken(token);
                this._token = token;
                q.resolve();
            }
        } catch(err){
            q.reject()
        }
        return q.promise;
    }

    private mendeleyLogin(authenticationUri: string): IPromise<{}>{
        let q = this.$q.defer();
        this.popupMendeleyLoginWin = this.$window.open(authenticationUri, 'mendeleylogin', 'toolbar=yes,scrollbars=yes,resizable=yes');
        if(!this.popupMendeleyLoginWin || this.popupMendeleyLoginWin.closed){
            q.reject();
            return q.promise;
        }
        this.$window.removeEventListener('storage',this.storageEventHandler);
        this.storageEventHandler = (event) => {
            if(event.key === 'mendeley_code'){
                let authCode = JSON.parse(event.newValue);
                let origState = authenticationUri.split('state=')[1].split('&')[0];
                if(_get(authCode, 'state') === origState){
                    this.$window.removeEventListener('storage',this.storageEventHandler);
                    let result = {
                        code : _get(authCode, 'code')
                    };
                    q.resolve(result);
                }
            }
        };
        this.$window.addEventListener('storage',this.storageEventHandler);
        let checkMendeleyClosed = this.$interval(() => {
            if(!this.popupMendeleyLoginWin || this.popupMendeleyLoginWin.closed){
                this.$window.removeEventListener('storage',this.storageEventHandler);
                this.$interval.cancel(checkMendeleyClosed);
            }
        },500);
        return q.promise;  
    }

    private authorizationUrlRequest(): IPromise<{}>{
        return this.$http.get(this.MENDELEY_API_URL + '/authorize' + (getBackendSystem() === 'suprima' ? '?vid=' + getVid() : '')) 
        ;
    }

    private tokenRequest(payload: Object): IPromise<{}>{
        return this.$http.post(this.MENDELEY_API_URL + '/token' + (getBackendSystem() === 'suprima' ? '?vid=' + getVid() : ''), payload);
    }

    private setSessionToken(token: Object){
        this.sharedSessionStorage.setItem(this.MENDELEY_TOKEN, JSON.stringify(token));
    }

    private getSessionToken(): Object{
        return JSON.parse(sessionStorage.getItem(this.MENDELEY_TOKEN));
    }

    private isAuthorizationNeeded(token: Object): boolean{
        if(_get(token,'access_token') && _get(token,'expires_in')){
            let expiry = _get(token,'expires_in');
            let currTime = new Date().getTime();
            if(currTime < expiry){
                return false;
            }
        }
        return true;
    }

    private createDocumentRequest(data: Object): IPromise<{}>{
        let config = {
            headers: {
                'Authorization': 'Bearer ' + _get(this._token,'access_token'),
                'Accept': 'application/vnd.mendeley-document.1+json',
                'Content-Type': 'application/vnd.mendeley-document.1+json'
            }  
        };
        
        
        // in case 'year' contain 'u' or '?' then we should not send the year
        let year = _get(data,'year');
        if(year && (year.indexOf("u") != -1 || year.indexOf("?") != -1)){	
			            _set(data, 'year', '');
		        }
		
        return this.$http.post(MENDELEY_CREATE_DOCUMENT_API + (getBackendSystem() === 'suprima' ? '?vid=' + getVid() : ''), data, config);  
    }

    private getItemTitle(item): string{
        if(item){
            if(!Array.isArray(item)){
                return _escape(_get(item,'pnx.display.title[0]',''));
            } else if(Array.isArray(item) && item.length === 1){
                return _escape(_get(item[0],'pnx.display.title[0]',''));
            }
            return '';
        }
        return '';
     }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/mendeleyAction/mendeley.service.ts